const style = {
  main: {
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  head: {
    width: '100%'
  },
  headText: {
    position: 'absolute',
    top: '1rem',
    width: '100%',
    color: '#fff',
    fontSize: '0.45rem',
    lineHeight: '0.42rem',
    textAlign: 'center'
  },
  headIcon: {
    height: '0.5rem',
    width: '0.5rem',
    lineHeight: '0.42rem',
    marginBottom: '-0.05rem',
    marginRight: '0.2rem'
  },
  info: {
    position: 'relative',
    height: '2.09rem',
    width: '100%',
    backgroundColor: '#fff',
    borderBottom: '0.18rem solid #F2F2F2',
    overflow: 'hidden'
  },
  infoItem: {
    height: '50%',
    width: '100%',
    fontSize: '0.4rem',
    lineHeight: '1.045rem',
    textIndent: '0.3rem'
  },
  disable: {
    marginTop: '0.5rem',
    fontSize: '0.4rem',
    textAlign: 'center',
    lineHeight: '0.6rem'
  },
  divider: {
    position: 'absolute',
    left: '0.3rem',
    top: '0',
    bottom: '0',
    margin: 'auto 0',
    height: '1px',
    width: '9rem',
    backgroundColor: '#E4E4E4',
    border: 'none',
    outline: 'none'
  },
  wx: {
    display: 'block',
    margin: '0 auto',
    marginTop: '0.78rem',
    height: '5rem'
  },
  wxName: {
    position: 'absolute',
    top: '9.63rem',
    left: 0,
    right: 0,
    fontSize: '0.7rem',
    textAlign: 'center'
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    height: '1.58rem',
    width: '100%',
    borderTop: '1px solid #E4E4E4',
    lineHeight: '1.58rem',
    textAlign: 'center'
  },
  operation: {
    height: '1.1rem',
    width: '9.3rem',
    border: 0,
    outline: 0,
    lineHeight: '1.1rem',
    color: '#fff',
    fontSize: '0.45rem',
    backgroundImage: 'linear-gradient(-135deg, #F48F00 0%, #FFB500 100%)',
    borderRadius: '0.06rem'
  }
}

export default {
  name: 'Received',

  props: ['start', 'end', 'type', 'eventName'],

  render () {
    return (
      <div style={style.main}>
        <img style={style.head} src={require('../../assets/images/gift-success-head.png')} alt="head"/>

        {
          this.type === 1
            ? <h1 style={style.headText}><img style={style.headIcon} src={require('../../assets/images/gift-success-got.png')}/>领取成功！</h1>
            : <h1 style={style.headText}><img style={style.headIcon} src={require('../../assets/images/gift-success-exclamatory.png')}/>来晚啦，课程已经被领取啦！</h1>
        }

        {
          this.type === 1
            ? (
              <section style={style.info}>
                <p style={style.infoItem}>学习时间：{this.start} 至 {this.end}</p>
                <hr style={style.divider}/>
                <p style={style.infoItem}>学习方式：{'每天通过微课公众号推送最新课程'}</p>
              </section>
            )
            : (
              <section style={style.info}>
                <p style={style.disable}>本次赠送仅限1人领取有效哦～<br/>你可以点击下方按钮，直接购买课程哦</p>
              </section>
            )
        }

        {
          this.type === 1
            ? (
              <div>
                <img style={style.wx} src={require('../../assets/images/gift-success-wx.png')} alt="wx"/>
                <h2 style={style.wxName}>wpsjingpinke</h2>
              </div>
            )
            : ''
        }

        <footer style={style.footer}>
          <button style={style.operation} onClick={() => this.$emit(this.eventName)}>{ this.type === 1 ? '查看课表' : '立即购买' }</button>
        </footer>
      </div>
    )
  }
}
